export const changeItineraryClassOpts = ( pnrValue, lastNameValue, post, store, cartID, listFlightInfo ) => {
  // revisando peticion de opts 
  const opts = {
    _meta: {
      class: 'ScheduleChangeRequest',
    },
    recordLocator : ( pnrValue ) ? pnrValue : '',
    lastName : ( lastNameValue ) ? lastNameValue : '',
    store: store ? store : '',
    pos: post ? post : '',
    // cartID: cartID ? cartID : '',
    listFlightInfo: listFlightInfo ? listFlightInfo : [],
  };

  return opts;
};

  